import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlane, faSchool, faStore } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faPlane, faSchool, faStore)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

let app = ''
const config = {
  apiKey: 'AIzaSyC9asgEYWe3VPZncfoYSnzKPfndLdSTjLo',
  authDomain: 'detectx-75efa.firebaseapp.com',
  databaseURL: 'https://detectx-75efa.firebaseio.com',
  projectId: 'detectx-75efa',
  storageBucket: 'detectx-75efa.appspot.com',
  messagingSenderId: '266049567653'
}

firebase.initializeApp(config)

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
